import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useSidebar } from "../../context/SidebarContext";
import logoNBlanc from "../../assets/img/logo_Niralakka_blanc.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { BsPersonFillAdd } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { FaFolderTree, FaFolderPlus, FaBars, FaXmark  } from "react-icons/fa6";
import { FaCalendarAlt, FaChevronCircleLeft, FaChevronCircleRight   } from "react-icons/fa";
import { BsFillBookmarksFill, BsBookmarkPlusFill,BsBookmarkCheckFill, BsBookmarkXFill} from "react-icons/bs";
import { BiSolidTachometer } from "react-icons/bi";
import { ImStatsDots } from "react-icons/im";
import NewProject from "../Modals/Create/NewProject";
import NewTicket from "../Modals/Create/NewTicket";
import NewClient from "../Modals/Create/NewClient";

// Component: Navbar
function Navbar() {
  const { hasPermission } = useAuth();
  const { collapsed, toggleSidebar } = useSidebar();

  // state : Responsive
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // State: modal visibilities
  const [showNewClient, setShowNewClient] = useState(false);
  const [showNewProject, setShowNewProject] = useState(false);
  const [showNewTicket, setShowNewTicket] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isClosingMenu, setIsClosingMenu] = useState(false);

  // Handle mobile menu close with animation
  const handleCloseMobileMenu = () => {
    setIsClosingMenu(true);
    setTimeout(() => {
      setShowMobileMenu(false);
      setIsClosingMenu(false);
    }, 400); // Match animation duration
  };

  // Handlers: open modals
  const handleShowNewProject = () => {
    setShowNewProject(true);
  }

  const handleShowNewTicket = () => {
    setShowNewTicket(true);
  }

  const handleShowNewClient = () => {
    setShowNewClient(true);
  }

  // Render: sidebar and modals
  // Mobile version

  if (isMobile) {
    return (
      <div style={{ zIndex: 2 }}>
        <nav className="navbar navbar-expand-md bg-primary navbar-dark" style={{ padding: "1rem 0" }}>
          <div className="container-fluid" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", minHeight: "70px" }}>
            {/* Logo */}
            <NavLink to="/home" className="navbar-brand d-flex align-items-center">
              <img src={logoNBlanc} alt="Logo" style={{ height: "40px" }} />
            </NavLink>

            {/* Mobile Navigation */}
            <div className="d-flex align-items-center gap-1">
              {/* Menu Burger */}
              <button
                className="btn btn-link text-white p-0"
                onClick={() => showMobileMenu ? handleCloseMobileMenu() : setShowMobileMenu(true)}
                title="Menu"
                style={{ 
                  fontSize: "28px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center", 
                  lineHeight: "1",
                  position: "relative",
                  width: "28px",
                  height: "28px"
                }}
              >
                <FaBars 
                  style={{
                    position: "absolute",
                    opacity: showMobileMenu ? 0 : 1,
                    transform: showMobileMenu ? "rotate(90deg) scale(0.8)" : "rotate(0deg) scale(1)",
                    transition: "opacity 0.3s ease, transform 0.3s ease"
                  }}
                />
                <FaXmark 
                  style={{
                    position: "absolute",
                    opacity: showMobileMenu ? 1 : 0,
                    transform: showMobileMenu ? "rotate(0deg) scale(1)" : "rotate(-90deg) scale(0.8)",
                    transition: "opacity 0.3s ease, transform 0.3s ease"
                  }}
                />
              </button>
            </div>
          </div>
        </nav>

        {/* Mobile Menu Dropdown */}
        {(showMobileMenu || isClosingMenu) && (
          <div 
            className="bg-gradient-primary navbar-dark" 
            style={{ 
              padding: "1rem 0.5rem",
              animation: isClosingMenu ? "slideUp 0.4s ease-out" : "slideDown 0.4s ease-out",
              transformOrigin: "top"
            }}
          >
            {/* Animation dropdown*/}
            <style>
              {`
                @keyframes slideDown {
                  from {
                    opacity: 0;
                    transform: translateY(-20px);
                    max-height: 0;
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                    max-height: 1000px;
                  }
                }
                @keyframes slideUp {
                  from {
                    opacity: 1;
                    transform: translateY(0);
                    max-height: 1000px;
                  }
                  to {
                    opacity: 0;
                    transform: translateY(-20px);
                    max-height: 0;
                  }
                }
              `}
            </style>

            {/* Dashboard & Calendar - Full width */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" }}>
              <NavLink 
                to="/home" 
                className="text-white d-flex flex-column align-items-center justify-content-center" 
                onClick={() => handleCloseMobileMenu()}
                style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
              >
                <BiSolidTachometer style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Tableau de bord</span>
              </NavLink>

              <NavLink
                to="/calendrier"
                className="text-white d-flex flex-column align-items-center justify-content-center"
                onClick={() => handleCloseMobileMenu()}
                style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
              >
                <FaCalendarAlt style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Calendrier</span>
              </NavLink>
            </div>

            {/* Client section */}
            {(hasPermission('CREATE_CLIENT') || hasPermission('SEE_CLIENT')) && (
              <>
                <div className="text-white" style={{ fontSize: "0.7rem", fontWeight: "bold", padding: "0.5rem 1rem", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7 }}>CLIENT</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" }}>
                  {hasPermission('CREATE_CLIENT') && (
                    <button
                      className="text-white d-flex flex-column align-items-center justify-content-center btn btn-link p-0"
                      onClick={() => {
                        handleShowNewClient();
                        setShowMobileMenu(false);
                      }}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.30)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s", border: "none" }}
                    >
                      <BsPersonFillAdd style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "600", textAlign: "center" }}>Nouveau client</span>
                    </button>
                  )}

                  {hasPermission('SEE_CLIENT') && (
                    <NavLink 
                      to="/clients" 
                      className="text-white d-flex flex-column align-items-center justify-content-center" 
                      onClick={() => setShowMobileMenu(false)}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
                    >
                      <FontAwesomeIcon icon={faUsers} style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Liste clients</span>
                    </NavLink>
                  )}
                </div>
              </>
            )}

            {/* Ticket section */}
            {(hasPermission('CREATE_TICKET') || hasPermission('SEE_TICKET') || hasPermission('APPROVE_TICKET')) && (
              <>
                <div className="text-white" style={{ fontSize: "0.7rem", fontWeight: "bold", padding: "0.5rem 1rem", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7 }}>TICKET</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" }}>
                  {hasPermission('CREATE_TICKET') && (
                    <button
                      className="text-white d-flex flex-column align-items-center justify-content-center btn btn-link p-0"
                      onClick={() => {
                        handleShowNewTicket();
                        setShowMobileMenu(false);
                      }}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.30)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s", border: "none" }}
                    >
                      <BsBookmarkPlusFill style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "600", textAlign: "center" }}>Nouveau ticket</span>
                    </button>
                  )}

                  {hasPermission('SEE_TICKET') && (
                    <NavLink 
                      to="/tickets" 
                      className="text-white d-flex flex-column align-items-center justify-content-center" 
                      onClick={() => setShowMobileMenu(false)}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
                    >
                      <BsFillBookmarksFill style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Tickets ouverts</span>
                    </NavLink>
                  )}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" }}>
                  {hasPermission('APPROVE_TICKET') && (
                    <NavLink 
                      to="/ticket-attente-approbation" 
                      className="text-white d-flex flex-column align-items-center justify-content-center" 
                      onClick={() => setShowMobileMenu(false)}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
                    >
                      <BsBookmarkCheckFill style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Tickets à approuver</span>
                    </NavLink>
                  )}

                  {hasPermission('SEE_TICKET') && (
                    <NavLink 
                      to="/tickets-fermes" 
                      className="text-white d-flex flex-column align-items-center justify-content-center" 
                      onClick={() => setShowMobileMenu(false)}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
                    >
                      <BsBookmarkXFill style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Tickets fermés</span>
                    </NavLink>
                  )}
                </div>
              </>
            )}

            {/* Project section */}
            {(hasPermission('CREATE_PROJECT') || hasPermission('SEE_PROJECT')) && (
              <>
                <div className="text-white" style={{ fontSize: "0.7rem", fontWeight: "bold", padding: "0.5rem 1rem", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7 }}>PROJET</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" }}>
                  {hasPermission('CREATE_PROJECT') && (
                    <button
                      className="text-white d-flex flex-column align-items-center justify-content-center btn btn-link p-0"
                      onClick={() => {
                        handleShowNewProject();
                        setShowMobileMenu(false);
                      }}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.30)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s", border: "none" }}
                    >
                      <FaFolderPlus style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "600", textAlign: "center" }}>Nouveau projet</span>
                    </button>
                  )}

                  {hasPermission('SEE_PROJECT') && (
                    <NavLink 
                      to="/projets" 
                      className="text-white d-flex flex-column align-items-center justify-content-center" 
                      onClick={() => setShowMobileMenu(false)}
                      style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", cursor: "pointer", transition: "background 0.2s" }}
                    >
                      <FaFolderTree style={{ fontSize: "28px", marginBottom: "0.5rem" }} />
                      <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Projets</span>
                    </NavLink>
                  )}
                </div>
              </>
            )}

            {/* Stats section */}
            {hasPermission('SEE_STATS') && (
              <>
                <div className="text-white" style={{ fontSize: "0.7rem", fontWeight: "bold", padding: "0.5rem 1rem", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7 }}>STATS</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
                  <NavLink
                    to="/statistiques"
                    className="text-white d-flex flex-column align-items-center justify-content-center"
                    style={{ padding: "1rem", background: "rgba(255,255,255,0.1)", borderRadius: "0.5rem", textDecoration: "none", transition: "background 0.2s" }}
                  >
                    <ImStatsDots style={{ fontSize: "1.3rem", marginBottom: "0.3rem" }} />
                    <span style={{ fontSize: "0.85rem", fontWeight: "500", textAlign: "center" }}>Statistiques</span>
                  </NavLink>
                </div>
              </>
            )}
          </div>
        )}

        {/* Modals */}
        <NewClient showNewClient={showNewClient} setShowNewClient={setShowNewClient} />
        <NewProject showNewProject={showNewProject} setShowNewProject={setShowNewProject} />
        <NewTicket showNewTicket={showNewTicket} setShowNewTicket={setShowNewTicket} />
      </div>
    );
  }


  
  // Render: sidebar and modals
  //desktop version
  return (
    <div style={{ zIndex: 2 }}>
      <ul
        className={
          "navbar-nav bg-gradient-primary sidebar sidebar-dark accordion " +
          (collapsed ? "toggled" : "")
        }
        id="accordionSidebar"
        style={{ transition: "all 0.3s ease" }}
      >
        {/* Brand */}
        <NavLink to="/home" className="sidebar-brand d-flex align-items-center justify-content-center">
          <img src={logoNBlanc} alt="Logo" />
        </NavLink>

        <hr className="sidebar-divider my-0" />

        {/* Dashboard link */}
        <li className="nav-item active">
          <NavLink to="/home" className="nav-link">
            <BiSolidTachometer className="mr-2" />
            {!collapsed && <span>Tableau de bord</span>}
          </NavLink>
        </li>

        {/* Calendar link */}
        <li className="nav-item">
          <NavLink to="/calendrier" className="nav-link" title={collapsed ? "Calendrier" : undefined}>
            <FaCalendarAlt className="mr-2" />
            {!collapsed && <span>Calendrier</span>}
          </NavLink>
        </li>

        <hr className="sidebar-divider" />

        {/* Client section */}
        {!collapsed && <div className="sidebar-heading">Client</div>}

        {hasPermission('CREATE_CLIENT') && (
          <li className="nav-item active">
            <button
              id="addClientBtn"
              className="nav-link"
              onClick={handleShowNewClient}
              title={collapsed ? "Nouveau client" : undefined}
            >
              <BsPersonFillAdd className="mr-2" />
              {!collapsed && <span>Nouveau client</span>}
            </button>
          </li>
        )}

        {hasPermission('SEE_CLIENT') && (
          <li className="nav-item">
            <NavLink to="/clients" className="nav-link">
              <FontAwesomeIcon icon={faUsers} className="mr-2" />
              {!collapsed && <span>Liste clients</span>}
            </NavLink>
          </li>
        )}

        <hr className="sidebar-divider " />

        {/* Ticket section */}
        {!collapsed && <div className="sidebar-heading ">Ticket</div>}


        {hasPermission('CREATE_TICKET') && (
          <li className="nav-item active">
            <button
              id="addTicketBtn"
              className="nav-link"
              onClick={handleShowNewTicket}
              title={collapsed ? "Nouveau ticket" : undefined}
            >
              <BsBookmarkPlusFill  className="mr-2" />
              {!collapsed && <span>Nouveau ticket</span>}
            </button>
          </li>
        )}

        {hasPermission('SEE_TICKET') && (
          <li className="nav-item ">
            <NavLink to="/tickets" className="nav-link">
              <BsFillBookmarksFill  className="mr-2" />
              {!collapsed && <span>Tickets ouverts</span>}
            </NavLink>
          </li>
        )}

        {hasPermission('APPROVE_TICKET') && (
          <li className="nav-item ">
            <NavLink to="/ticket-attente-approbation" className="nav-link">
              <BsBookmarkCheckFill  className="mr-2" />
              {!collapsed && <span>Tickets à approuver</span>}
            </NavLink>
          </li>
        )}

        {hasPermission('SEE_TICKET') && (
          <li className="nav-item ">
            <NavLink to="/tickets-fermes" className="nav-link">
              <BsBookmarkXFill className="mr-2" />
              {!collapsed && <span>Tickets fermés</span>}
            </NavLink>
          </li>
        )}

        <hr className="sidebar-divider " />

        {/* Project section */}
        {(hasPermission('CREATE_PROJECT') || hasPermission('SEE_PROJECT')) && (
          <>
            {!collapsed && <div className="sidebar-heading ">Projet</div>}

            {hasPermission('CREATE_PROJECT') && (
              <li className="nav-item active">
                <button
                  id="addProjetBtn"
                  className="nav-link"
                  onClick={handleShowNewProject}
                  title={collapsed ? "Nouveau projet" : undefined}
                >
                  <FaFolderPlus className="mr-2" />
                  {!collapsed && <span>Nouveau projet</span>}
                </button>
              </li>
            )}

            {hasPermission('SEE_PROJECT') && (
              <li className="nav-item ">
                <NavLink to="/projets" className="nav-link">
                  <FaFolderTree className="mr-2" />
                  {!collapsed && <span>Projets</span>}
                </NavLink>
              </li>
            )}

            <hr className="sidebar-divider " />
          </>
        )}

        {/* Stats section */}
        {hasPermission('SEE_STATS') && (
          <>
            {!collapsed && <div className="sidebar-heading ">Stats</div>}

            <li className="nav-item">
              <NavLink to="/statistiques" className="nav-link">
                <ImStatsDots className="mr-2" />
                {!collapsed && <span>Statistiques</span>}
              </NavLink>
            </li>
          </>
        )}

        <hr className="sidebar-divider d-none d-md-block" />

        {/* Collapse toggle */}
        <div className="text-center d-none d-md-inline">

          {collapsed ? (
            <FaChevronCircleRight
              className="rounded-circle border-0"
              onClick={toggleSidebar}
              style={{marginTop: '10px', marginBottom: '20px', color: '#fff', cursor: 'pointer', fontSize: '25px' }}
            />
          ) : (
            <FaChevronCircleLeft
              className="rounded-circle border-0"
              onClick={toggleSidebar}
              style={{marginTop: '10px',marginBottom: '20px', color: '#fff', cursor: 'pointer', fontSize: '25px' }}
            />
          )}

        </div>
      </ul>

      {/* Modals */}
      <NewClient showNewClient={showNewClient} setShowNewClient={setShowNewClient} />
      <NewProject showNewProject={showNewProject} setShowNewProject={setShowNewProject} />
      <NewTicket showNewTicket={showNewTicket} setShowNewTicket={setShowNewTicket} />

    </div>
  );
}

export default Navbar;
